import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CreateResult } from "../../models/create-result";
import { takeUntil } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { TerminalConfigService } from "../../services/terminal-config.service";
import { ChangeDetectorRef } from '@angular/core';
import { InteractionTypeEnum } from '../../models/interaction-type-enum';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { AuthenticationService } from "../../services/authentication.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormatHelper } from "../../helpers/format-helper";
import { MerchantReportDTViewModel } from '../../models/merchant-report-dt-view-model';
import { ReportService } from '../../services/report.service';
import { Select2OptionData } from 'ng-select2';
import { ClientReportDTViewModel } from '../../models/client-report-dt-view-model';
import { TerminalReportDTViewModel } from '../../models/terminal-report-dt-view-model';
import { MerchantGroupReportDTViewModel } from '../../models/merchant-group-report-dt-view-model';
import { ParticipantMappingViewModel } from '../../models/participant-mapping-view-model';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { ParticipantService } from '../../services/participant.service';
import { UserProfileComponent } from '../../authentication/user-profile/user-profile.component';
import { UserViewModel } from '../../models/user-view-model';
import { ReportUserViewManagementComponent } from './report-user-view-management/report-user-view-management.component';



@Component({
  selector: 'app-report-user-management',
  templateUrl: './report-user-management.component.html',
  styleUrls: ['./report-user-management.component.scss']
})
export class ReportUserManagementComponent implements OnInit, OnDestroy {
  public merchantForm: FormGroup;
  public submitted = false;
  public id: string;
  public createResult: CreateResult;
  private _destroyed$ = new Subject<any>();
  public error = false;
  public errorMessage = "";
  public canAdd: boolean;

  public dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<boolean> = new Subject();
  private loaded = false;

  public disabled: boolean;
  public warning: string;
  public raiseWarning: boolean;
  public danger: string;
  public raiseDanger: boolean;
  public displayMPOSContent: boolean;
  public merchants: MerchantReportDTViewModel;
  public clients: Select2OptionData[];
  public allClients: ClientReportDTViewModel[];
  public terminals: TerminalReportDTViewModel[];
  public allTerminals: TerminalReportDTViewModel[];
  public allMerchantGroups: MerchantGroupReportDTViewModel[];

  public participants: Select2OptionData[];
  public allParticipants: ParticipantViewModel[];
  public allUsers: UserViewModel[]; 
  public selectedTerminal: string;
  public selectedParticipant: string;
  public selectedMerchantGroupId: string;
  public NoUsers: boolean;
  public newMerchant: boolean;

  public selectedParticipantId: number;
  
  public selectedParticipants: string[] = [];

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private fb: FormBuilder,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _formBuilder: FormBuilder,
    private _formatHelper: FormatHelper,
    private _reportService: ReportService,
    private _ngxLoader: NgxUiLoaderService,
    private _participantService: ParticipantService) {

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {

      this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.ManageTutukaManagementReportSetups], []);
      if (!this.canAdd) {
        this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
        this._router.navigate(['/']);
      }
      debugger;
      this.selectedParticipantId = this._userDataStore.selectedParticipant.id;
      this.selectedParticipant = "" + this.selectedParticipantId;
      this.allUsers = await this._reportService.GetAllUsersByParticipant(this.selectedParticipant);

      //this.allParticipants = await this._reportService.GetAllParticipants();

    });
  }

  public async ngOnInit(): Promise<void> {

  }


  public async participantChange(): Promise<void> {
    if (this.selectedParticipant != undefined && this.selectedParticipant != '') {

      this.allUsers = await this._reportService.GetAllUsersByParticipant(this.selectedParticipant);
     
    }
  }

  public async manageUser(user: UserViewModel): Promise<void> {   

    this._router.navigate(['management', 'report-user-view', user.id]);
    //this.resetDatatable();
  }


  public ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
    this.dtTrigger.unsubscribe();
  }

}
